import React, { useEffect } from "react";
import { Image } from "@wss/image";
import useIsMounted from "~/common/useIsMounted";
import { ProductDocument } from "~/ProductDetails/ProductDetailPageResult";
import pdfNoPreview from "./img/pdf_no_preview.jpg";

interface Props {
  productDocuments: ProductDocument[];
}

const fixDocumentImage = (
  event: React.SyntheticEvent<HTMLImageElement, Event>,
) => {
  const documentImage = event.target as HTMLImageElement;
  documentImage.src = pdfNoPreview;
};

const ProductDocuments = ({ productDocuments }: Props) => {
  const isMounted = useIsMounted();

  useEffect(() => {
    window.dispatchEvent(new Event("resourcesLoaded"));
  }, [isMounted]);

  return (
    <>
      {isMounted &&
        productDocuments.map((document) => {
          const link = document.externalUrl
            ? document.externalUrl
            : document.filePath;
          const title =
            document.externalUrl && document.externalUrlTitle
              ? document.externalUrlTitle
              : document.name;
          const thumbnail =
            document.externalUrl && document.externalUrlTitle
              ? `//cdnimg.webstaurantstore.com/uploads/design/2020/10/external-link_2x.png`
              : `/images${document.thumbnailPath}`;

          return (
            <a
              href={link}
              className="item"
              title={title}
              target="_blank"
              rel="noopener noreferrer"
              key={title}
              onAuxClick={
                document.externalUrl ? (e) => e.preventDefault() : undefined
              }
              onContextMenu={
                document.externalUrl ? (e) => e.preventDefault() : undefined
              }
              data-toggle={
                document.externalUrl ? "externalLinkModal" : undefined
              }
            >
              <Image
                src={thumbnail}
                alt={title}
                title={title}
                onError={fixDocumentImage}
                loading="lazy"
                height={132}
                width={102}
              />
              <span>
                {document.type.toLowerCase() === "extra" &&
                document.customType &&
                document.customType.length > 0
                  ? document.customType
                  : document.type}
              </span>
            </a>
          );
        })}
    </>
  );
};

export default ProductDocuments;
